// Shared by bulk import and lookup display so ambiguity is handled consistently.
export const normalizeDlpLookupName = (name: string) => name.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
